import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function TransparentInspection() {
  const listItems = ['Photos and video taken directly from your vehicle', 'Technician notes explained in plain language', 'Repairs ranked by urgency so you decide what matters now vs later', 'Nothing begins without your approval'];
  return <section className="py-20 px-4 bg-brand-light" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-250">
          <img src="https://cdn.magicpatterns.com/uploads/v5w4cpb7uAJvjUTD8b3jRB/Lancer_Circle3x.png" alt="Lancer Service - Auto Repair & Maintenance" className="w-40 h-40 md:w-52 md:h-52 mx-auto mb-8 drop-shadow-lg" data-id="element-251" />
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-252">
            Transparent by design
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-253">
            See exactly what we see
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-254">
            Before we recommend a single repair, you receive a digital
            inspection report with photos and video from your actual vehicle —
            the same information our technicians are looking at.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200 shadow-sm mb-10" data-id="element-255">
          <ul className="space-y-6" data-id="element-256">
            {listItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-257">
                <CheckCircleIcon className="w-6 h-6 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-258" />
                <span className="text-lg text-gray-800 font-medium" data-id="element-259">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-260">
          <p className="text-gray-600 italic text-lg max-w-2xl mx-auto" data-id="element-261">
            Accurate diagnosis simply ensures you only replace parts that
            actually need replacing.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="text-center mt-12" data-id="element-262">
          <a href="tel:6512240267" className="inline-flex justify-center items-center px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20" data-id="element-263">
            Schedule a free Inspection
          </a>
          <p className="text-gray-500 text-sm mt-3" data-id="element-264">
            See exactly what we find before approving any repair.
          </p>
        </motion.div>
      </div>
    </section>;
}